import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { PRODUTOS_GRID_ENDPOINT } from '../../../hooks/constants';

const SORT_CONFIG = { field: 'dataAtualizacao', type: 'DESC' };

export const useProdutos = () => {
  const { backendPut, backendPost, backendDelete, backendGetBlob } = Sebrae.useBackend();
  const { fetchData, data, loading, error } = Sebrae.usePagination(PRODUTOS_GRID_ENDPOINT);

  const handleSave = React.useCallback(
    async (formData) => {
      try {
        await backendPost('/v1/produto/', formData);
        fetchData({ sort: SORT_CONFIG });
        return { sucess: true };
      } catch (e) {
        console.error('Erro ao salvar produto:', e);
        return { ...e };
      }
    },
    [backendPost, fetchData],
  );

  const handleUpdate = React.useCallback(
    (id) => async (formData) => {
      try {
        await backendPut(`/v1/produto/${id}`, formData);
        fetchData({ sort: SORT_CONFIG });
        return { sucess: true };
      } catch (e) {
        console.error('Erro ao atualizar produto:', e);
        return { ...e };
      }
    },
    [backendPut, fetchData],
  );

  const handleDelete = React.useCallback(
    async (produtoId) => {
      try {
        await backendDelete(`/v1/produto/${produtoId}`);
        fetchData({ sort: SORT_CONFIG });
        return { sucess: true };
      } catch (e) {
        console.error('Erro ao excluir produto:', e);
        return { ...e };
      }
    },
    [backendDelete, fetchData],
  );

  const getImageBlob = React.useCallback(
    (produtoId, tipo) => {
      if (!produtoId) return undefined;
      return () => backendGetBlob(`v1/produto/${produtoId}/${tipo}/imagem`);
    },
    [backendGetBlob],
  );

  return {
    produtos: data.items,
    total: data.total,
    loading,
    error,
    fetchData,
    handleSave,
    handleUpdate,
    handleDelete,
    getImageBlob,
  };
};
